import apiClient from "../apiClient";

const resource = "Courses";

export default {
    getCourses: params => apiClient.get(`${resource}/Courses?${params}`),

};
